import React, { lazy } from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-8 md:pt-16 pb-6 md:pb-8 px-4 bg-brand-dark/50" data-id="element-236">
      <div className="max-w-5xl mx-auto text-center" data-id="element-237">
        <div className="inline-flex items-center justify-center gap-2 bg-yellow-100/10 text-yellow-400 border border-yellow-400/20 font-bold px-4 py-2 rounded-full mb-4 md:mb-6" data-id="element-238">
          <span data-id="element-239">🏆</span> El sistema N°1 para docentes argentinos
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-white mb-2 md:mb-4" data-id="element-240">
          🤖 SISTEMA DOCENTE 360
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-6 md:mb-8" data-id="element-241">
          IA PARA RECUPERAR TUS FINES DE SEMANA
        </h3>

        <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-5 md:mb-10" data-id="element-242">
          5 Tomos con +120 prompts listos para usar todo el año. Planificación,
          secuencias, evaluaciones, burocracia y PPI resueltos en minutos con
          ChatGPT gratuito.
        </p>

        <div className="flex flex-wrap justify-center md:gap-4 mb-5 md:mb-10 gap-[2px]" data-id="element-243">
          {['1°', '2°', '3°', '4°', '5°'].map(year => <div key={year} className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-black text-brand-blue border-2 border-brand-blue/10" data-id="element-244">
              {year}
            </div>)}
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-245">
          <div className="text-left bg-white p-5 md:p-8 rounded-2xl shadow-xl" data-id="element-246">
            <h4 className="text-2xl font-black text-brand-dark mb-4 md:mb-6 border-b pb-4" data-id="element-247">
              5 TOMOS COMPLETOS
            </h4>
            <ul className="space-y-4" data-id="element-248">
              {['Por año', 'Con actividades secuenciadas', 'Con laboratorios reales', 'Con evaluaciones'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-bold text-gray-800" data-id="element-249">
                  <CheckCircleIcon className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-250" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-251">
            <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-252">
              <img src="https://cdn.magicpatterns.com/uploads/pxtCzzbsE2AVRW2JRw1DED/docente360-pack2-1200.webp" alt="Sistema Docente 360" className="w-full drop-shadow-2xl rounded-xl" loading="lazy" width={768} height={1024} data-id="element-253" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}